import { gql } from "@apollo/client";

/**
 * Fetch nav_config from the current user's tenant.
 * Returns a JSON string that the editor parses client-side.
 */
export const GET_NAV_CONFIG = gql`
  query NavConfig {
    currentTenant {
      id
      name
      domain
      navConfig
      announcementConfig
      chromeConfigDraft
      chromeConfigPublished
      logoUrl
      featureConfig
    }
  }
`;
